import {inject, Injectable} from "@angular/core";
import {from, mergeMap, Observable} from "rxjs";
import {filter, map} from "rxjs/operators";
import {Notification} from "../../models/notification";
import {User} from "../../models/user";
import {WebsocketService} from "../websocket.service";


@Injectable({ providedIn: 'root' })
export class RoleTopicService {
  private websocketService = inject(WebsocketService);
  createRoleTopic(user: User): Observable<Notification> {
    if (!user || !user.roles) {
      throw new Error('a user with roles is required');
    }

    return from(user.roles).pipe(
      filter(role => role === 'DIRECTOR' || role === 'QHSE'), // At the moment, only subscribing for those two roles
      map(role => `/digiproc/topic/role/${role}`),
      mergeMap(topic => this.websocketService.createTopic<Notification>(topic, {observe: 'body'}))
    );
  }
}
